import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=9bb84c7e&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=9bb84c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb84c7e",
  null
  
)

export default component.exports